export default __webpack_public_path__ + "static/scenariusze_grafika-65216ebd6e9b61285fffa8afb740f42e.svg";